export const baseURL = "https://admin.cmartt.net/";
export const secretKey = "5TIvw5cpc0";
export const projectName = "Cmartt";
